<template>
  <div class="training-school">
    <div class="training-school-inner">
      <div class="training-school-head">
        <img src="@/assets/newIndex/newOpen.png" />
        <ul class="training-schoolul">
          <li
            class="training-school-headtext"
            v-for="(item,index) in tablist"
            :key="index"
            :class="{ active: tabActive === index }"
            @click="tabHandleChange(index,item.id)"
          >{{item.title}}</li>
        </ul>

        <div class="gdbox" @click="acadMore()">
          <div class="gdtext"><span>查看更多</span><i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
      <!-- 渐变线条 -->
      <div class="gitern"></div>
      <div class="trainingvideo">
        <div class="trainingvideright">
          <div
            class="trainingimgli"
            v-for="(item,index) in QuestionList"
            :key="index"
            @click="newsVideo(item)"
          >
            <img :src="item.imgUrl" />

            <div class="traingimgtext onele">{{item.name}}</div>
            <!-- <div style="padding-left:10px;padding-top:5px">
              <el-rate v-model="item.levels" disabled disabled-void-color="#cccccc"></el-rate>
            </div>-->
            <div
              style="font-size:12px;color:#666666;margin: 0px 0px 7px 2px;line-height: 18px;"
            >{{item.deptName}}</div>
            <div class="traingimgnametxtlil">
              <div class="traingimgname">{{item.jzDicName}}</div>
              <div style="flex:1"></div>
              <div class="traniBox">
                <div class="trainicon" style="margin-right:14px">
                  <img src="@/assets/resource/u231.svg" alt />
                  {{item.visitNum}}
                </div>
                <div class="trainicon" style="margin-right:14px">
                  <img src="@/assets/videoimg/studycommentPlin.svg" alt />
                  <span>{{item.talkCount}}</span>
                </div>
                <div class="trainicon">
                  <img src="@/assets/videoimg/like.svg" style="width:13px;height:13px" />
                  <span>{{item.assistCount}}</span>
                </div>
              </div>
            </div>
          </div>
          <div style="flex: 1;"></div>
          <nodata v-if="QuestionList.length==0" style="margin: 0 auto; margin-top: 100px;"></nodata>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as studyClassIndex from '@/api/studyClass/index';
import treeSelectt from '@/components/treeSelectt'; //文本框选中部门树形结构异步加载
import elSelectc from '@/components/elSelect';
import * as resourceInfo from '@/api/resources/index.js';
export default {
  components: {
    treeSelectt,
    elSelectc,
  },
  data() {
    return {
      QuestionList: [],
      levels: 5,
      tabActive: 0,
      listQuery: {
        title: '',
        address: null,
        deptId: 0,
        JzId: null,
      },
      tablist: [
        {
          title: '最新发布',
          id: 5,
        },
      ],
      options: [
        {
          value: 1,
          label: '专业课',
        },
        {
          value: 3,
          label: '公共课',
        },
      ],
      sid: +new Date(),
      typeOne: 0, //传0过去只显示部门，不穿显示所有部门
      parentIdOne: 2, //只显示该部门以下的
      defaultCheckedKeys: [],
    };
  },
  mounted() {
    this.MoocQuestionList();
  },
  methods: {
    // 选择警钟类型返回
    selectDatajzDicId(val) {
      this.listQuery.jzId = val.value;
      this.MoocQuestionList();
    },
    //警种部门
    AddDept(checkedIds, checkedData) {
      // console.log(checkedData);
      this.listQuery.deptId = checkedData.id;
    },
    // 更多
    acadMore() {
      this.$router.push('/mooc/policeAcademyMore');
    },
    MoocQuestionList() {
      let data = { top: 10 };
      studyClassIndex.GetWkNewList(data).then((res) => {
        // console.log(res);
        this.QuestionList = res.result;
      });
    },
    //跳转到新页面进入视频的播放
    newsVideo(item) {
      // this.$router.push('/studyclassDetail?id=' + id);
      resourceInfo.DocumentRead(item.id).then((res) => {});
      this.$router.push('/sourceslist/videoLearn?id=' + item.id);
    },
    tabHandleChange(index, id) {
      this.tabActive = index;
      this.levels = id;
      this.$emit('tabChange', this.tabActive);
      this.MoocQuestionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.training-school {
  > .training-school-inner {
    width: 1200px;
    min-height: 550px;
    margin: 0 auto;
    border-radius: 6px;
    background-color: #fff;
    .training-school-head {
      width: 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0px 19px 6px 21px;
      &>img{
        height: auto;
        width: 40px;
        margin-right: 13px;
      }
      @include themeify {
        border-color: themed('color-border-base');
      }
      .training-schoolul {
        flex: 1;
        display: flex;
        .training-school-headtext {
          font-size: 16px;
          font-weight: 700;
          line-height: 24px;
          &.active {
            @include themeify {
              color: #000000;
              font-weight: bold;
              border-bottom-color: themed('color-background-base');
            }
          }
        }
      }
    }
    .trainingvideo {
      display: flex;
      .trainingvideright {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        box-sizing: border-box;
        padding: 30px 13px 10px 13px;
        .trainingimgli {
          background-color: #fff;
          width: 222px;
          box-sizing: border-box;
          padding: 6px 7px 8px 7px;
          margin: 0px 16px 20px 0px;
          cursor: pointer;
          box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
          &:hover {
            box-shadow: 2px 2px 6px rgb(242 242 242 / 99%);
            transform: scale(1.02);
          }
          &>img {
            width: 100%;
            height: 138px;
            border-radius: 2px;
            margin-bottom: 6px;
          }
          .traingimgtext {
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: #272636;
            box-sizing: border-box;
            padding: 0px 2px;
          }
          .traingimgnametxtlil {
            color: #999;
            display: flex;
            .traingimgname {
              padding: 2px 4px;
              color: #fff;
              background-color: #649FED;
              border-radius: 4px;
              font-size: 12px;
              line-height: 18px;
              margin-right: 8px;
            }
            .traniBox {
              display: flex;
              padding-right: 5px;
              .trainicon {
                display: flex;
                align-items: center;
                font-size: 10px;
                line-height: 15px;
                font-weight: 400;
                img {
                  width: 16px;
                  height: 16px;
                  margin-right: 2px;
                }
              }
            }
          }
        }
        .trainingimgli:nth-child(5n){
          margin-right: 0px;
        }
      }
    }
  }
}

.gdbox {
  display: flex;
  align-items: right;
  color: #4192FF;
  .gdtext {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      color: #4192FF;
    }
  }
}

.play-btn {
  font-size: 50px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }
}
.gitern {
  height: 2px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}
.search-box {
  width: 1200px;
  border-radius: 5px;
  height: 80px;
  background-color: #5c7dbd;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .select-box {
    display: flex;
    align-items: center;
    .select-title {
      color: white;
      font-weight: 700;
      font-size: 16px;
    }
  }
}

.onele {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
